export default "__VITE_ASSET__05tzqZmp__"